<template>
  <div>
    <Modal
      :title="formData.id ? '编辑员工' : '新增员工'"
      v-model="visible"
      width="800"
      class="my-modal top add-user-wrap"
      :mask-closable="false"
      :footer-hide="true"
    >
      <Form ref="form" v-if="visible" :model="formData" class="page-form less" :label-width="95">
        <h2>基础信息</h2>
        <FormItem label="所属转介人" prop="tenantId" :rules="$units.formRule.required('请选择')">
          <selectTree
            v-if="merchantType == 3"
            v-model="formData.tenantId"
            type="5"
            url="/buz/merchant/read/tree"
            :params="{ nodeType: 0 }"
            :isAll="true"
            :disabled="!!formData.id"
            immediate
            :clearable="false"
            ref="selectTree"
          />
          <span v-else> {{ formData.orgName }}</span>
        </FormItem>

        <FormItem v-if="isIFA && formData.groupName" label="所属团队" key="groupId" prop="groupId">
          {{ formData.groupName }}
        </FormItem>
        <FormItem v-else-if="merchantType != 3 && !isIFA" label="所属团队" key="groupIds" prop="groupId">
          <Select v-model="formData.groupId" clearable @on-change="changeGroupId" filterable>
            <Option v-for="(bean, i) in groupList" :key="i" :value="bean.id">
              {{ bean.name }}
            </Option>
          </Select>
        </FormItem>
        <template v-if="isIFA">
          <FormItem prop="ifaType" key="groupId1" label="账号类型" :rules="$units.formRule.required('请选择', 'change', 'number')">
            <RadioGroup v-model="formData.ifaType" @on-change="changeIfaType">
              <Radio :label="1">正式</Radio>
              <Radio :label="2">潜在</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="staffNo" label="工号" key="staffNo" :rules="$units.formRule.required('请输入', 'blur')">
            <Input v-model="formData.staffNo" placeholder="请输入" />
          </FormItem>
          <FormItem prop="name" label="中文姓名" key="name" :rules="$units.formRule.required('请输入', 'blur')">
            <Input v-model="formData.name" placeholder="请输入" />
          </FormItem>
          <FormItem prop="englishName" label="英文姓名" key="englishName" :rules="$units.formRule.required('请输入', 'blur')">
            <Input v-model="formData.englishName" placeholder="请输入" />
          </FormItem>
          <FormItem
            label="入职时间"
            key="entryTime"
            prop="entryTime"
            :rules="formData.ifaType == '1' ? $units.formRule.objRequired('请选择') : { required: false }"
          >
            <DatePicker v-model="formData.entryTime" type="date" transfer placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" />
          </FormItem>
          <FormItem prop="ifaLevel" label="销售职级" key="ifaLevel" :rules="$units.formRule.required('请选择')">
            <lzDicSelect :disabled="!!formData.id" v-model="formData.ifaLevel" dicType="IFA_RANK" :transfer="true" clearable @change="changeIfaLevel">
            </lzDicSelect>
          </FormItem>

          <FormItem v-if="merchantType != 3" key="isLeader" prop="isLeader" label="是否团队长" :rules="$units.formRule.required('请选择')">
            <!-- 机构下直接新增员工的是否团队长只能选否 -->
            <RadioGroup v-model="formData.isLeader" @on-change="changeIsLeader">
              <Radio label="1" :disabled="!!formData.id">是</Radio>
              <Radio label="0" :disabled="!!formData.id">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem
            v-if="formData.isLeader == '1'"
            prop="groupLevel"
            key="groupLevel"
            label="团队长级别"
            :rules="$units.formRule.required('请选择团队长级别', 'change', 'number')"
          >
            <RadioGroup v-model="formData.groupLevel">
              <Radio :label="1" :disabled="!!formData.id">合伙人</Radio>
              <Radio :label="2" :disabled="!!formData.id">高级合伙人</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="formData.isLeader !== '1'" key="leaderId" label="团队长" prop="leaderId">
            <Select v-model="formData.leaderId" transfer clearable @on-change="changeLeaderId">
              <Option v-for="(item, index) in groupUserList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="企微账号" prop="customerVid" key="customerVid">
            <Select v-model="formData.customerVid" transfer clearable filterable>
              <Option v-for="(item, index) in qwUserList" :value="item.customerVid" :key="index">{{ item.customerName }}</Option>
            </Select>
          </FormItem>
          <FormItem label="推荐人" prop="refereeId" key="refereeId">
            <Select v-model="formData.refereeId" transfer clearable filterable>
              <Option v-for="(item, index) in refereeList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="辅导人" prop="mentorId" key="mentorId">
            <Select v-model="formData.mentorId" transfer clearable filterable>
              <Option v-for="(item, index) in mentorList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="育成人" prop="trainerId" key="trainerId">
            <Select v-model="formData.trainerId" transfer clearable filterable>
              <Option v-for="(item, index) in trainerList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="licence有效期" key="type" prop="date">
            <DatePicker
              v-model="formData.date"
              type="daterange"
              separator="至"
              transfer
              :editable="false"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </FormItem>
        </template>
        <template v-else>
          <FormItem prop="name" label="姓名" key="name" :rules="$units.formRule.required('请输入', 'blur')">
            <Input v-model="formData.name" placeholder="请输入" />
          </FormItem>
          <FormItem v-if="merchantType != 3" key="isLeader" prop="isLeader" label="是否团队长" :rules="$units.formRule.required('请选择')">
            <!-- 机构下直接新增员工的是否团队长只能选否 -->
            <RadioGroup v-model="formData.isLeader" @on-change="changeIsLeader">
              <Radio label="1" :disabled="!formData.groupId">是</Radio>
              <Radio label="0" :disabled="!formData.groupId">否</Radio>
            </RadioGroup>
          </FormItem>
        </template>

        <!-- 掩码手机号 -->
        <FormItem prop="mobile" label="手机号" key="mobile1" v-if="formData.id && formData.mobile && !formData.mobileEyeShow">
          <span @dblclick="openEye(formData, 'mobile')">{{ formData.mobile }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'mobile')"></i>
          </a>
        </FormItem>
        <FormItem v-else prop="mobile" label="手机号" key="mobile2" :rules="[validMobile]">
          <Input v-model="formData.mobile" placeholder="请输入" />
        </FormItem>

        <FormItem label="证件类型" prop="idType" key="idType">
          <Select v-model="formData.idType" transfer clearable @on-change="$set(formData, 'idNo', '')">
            <Option v-for="(item, index) in idTypeList" :value="item.value" :key="index">{{ item.txt }}</Option>
          </Select>
        </FormItem>
        <FormItem label="证件号" v-if="formData.id && formData.idNo && !formData.idNoEyeShow" key="idNo0">
          <span @dblclick="openEye(formData, 'idNo')">{{ formData.idNo }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'idNo')"></i>
          </a>
        </FormItem>
        <FormItem
          prop="idNo"
          label="证件号"
          :rules="$units.formRule.idCard('请输入正确的身份证号', false, 'blur')"
          v-else-if="formData.idType == '01'"
          key="idNo1"
        >
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem prop="idNo" label="证件号" :rules="strLength()" v-else-if="formData.idType == '02'" key="idNo2">
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem
          prop="idNo"
          label="证件号"
          :rules="$units.formRule.strLength('请输入正确的通行证件号', 8, false)"
          v-else-if="formData.idType == '16'"
          key="idNo16"
        >
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem prop="idNo" label="证件号" v-else-if="formData.idType == '07'" key="idNo7">
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem
          prop="idNo"
          label="证件号"
          key="idNo999"
          :rules="$units.formRule.strLength('请输入正确的外国人永久居留证件号', 15, false)"
          v-else-if="formData.idType == '999'"
        >
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem prop="idNo" label="证件号" v-else key="-">
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem prop="status" label="账号状态">
          <i-switch v-model="formData.status" size="large" true-value="1" false-value="0">
            <span slot="open">启用</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
        <FormItem v-if="isIFA && formData.ifaType == 1" prop="isLicence" label="持牌状态" :rules="$units.formRule.required('请选择', 'change', 'number')">
          <RadioGroup v-model="formData.isLicence">
            <Radio :label="1">持牌中</Radio>
            <Radio :label="2">已下牌</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="formData.id && isIFA" prop="activeStatus" key="activeStatus" label="active状态">
          <RadioGroup :disabled="!!formData.id" v-model="formData.activeStatus">
            <Radio :disabled="!!formData.id" label="1">是</Radio>
            <Radio :disabled="!!formData.id" label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="account" label="电子邮箱" key="email1" v-if="formData.id && formData.email1 && !formData.emailEyeShow">
          <span @dblclick="openEye(formData, 'email')">{{ formData.email }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'email')"></i>
          </a>
        </FormItem>
        <FormItem v-else label="电子邮箱" prop="email" key="email2" :rules="$units.formRule.email(false)">
          <lzEmailInput v-model="formData.email"></lzEmailInput>
        </FormItem>
        <FormItem v-if="isIFA" label="商务经理" prop="busserId" key="busserId" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.busserId" transfer clearable filterable placeholder="请选择">
            <Option v-for="(item, index) in busserList" :value="item.id" :key="index">{{ item.userName }}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="isIFA" label="自媒体运营" prop="operatorName" key="operatorName">
          <Input v-model="formData.operatorName" placeholder="请输入" />
        </FormItem>
        <h2>账号信息</h2>
        <!-- 掩码账号 -->
        <FormItem prop="account" label="登录账号" key="account1" v-if="formData.id && formData.account && !formData.accountEyeShow">
          <span @dblclick="openEye(formData, 'account')">{{ formData.account }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'account')"></i>
          </a>
        </FormItem>
        <FormItem
          prop="account"
          label="登录账号"
          key="account2"
          v-else
          :rules="[$units.formRule.required('请输入'), $units.formRule.str('不能含有特殊字符和标点符号'), forbidPureDigitsRule]"
        >
          <Input v-model="formData.account" placeholder="请输入" maxlength="20" />
        </FormItem>
        <FormItem v-if="!formData.id" key="password" prop="password" label="登录密码" :rules="$units.formRule.required('请输入', 'blur')">
          <Input v-model="formData.password" placeholder="请输入" />
        </FormItem>
        <FormItem v-if="!formData.id" key="password1" prop="password1" label="确认密码" :rules="$units.formRule.required('请输入', 'blur')" class="full">
          <Input v-model="formData.password1" placeholder="请输入" />
          <div class="info-text">密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种</div>
        </FormItem>
        <FormItem v-if="formData.id" key="password2" prop="password" label="登录密码">
          <Button type="primary" @click="$emit('editPassword', { id: formData.id })">修改密码</Button>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="loading">确认</Button>
      </div>
    </Modal>
    <!-- 解密组件 -->
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import lzDicSelect from '@/components/commons/lzDicSelect';
import lzEmailInput from '@/components/commons/lzEmailInput';
import validUserName from '@/components/commons/validUserName';
export default {
  mixins: [common],
  components: {
    selectTree,
    validUserName,
    lzDicSelect,
    lzEmailInput
  },
  props: {},
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    },
    // 渠道类型
    merchantType() {
      return this.userInfo.merchantType;
    }
  },
  data() {
    return {
      userInfo: {},
      visible: false,
      loading: false,
      idTypeList: [], //证件类型
      groupList: [], //团队
      data: {},
      formData: {
        status: '1',
        isLeader: '0',
        mobile: '',
        name: '',
        idNo: '',
        idType: '',
        account: '',
        password: '',
        password1: '',
        entryTime: '',
        ifaLevel: '',
        email: '',
        busserId: '',
        operatorName: ''
      },
      validMobile: {
        required: false,
        message: '请输入手机号',
        trigger: 'blur',
        validator(rule, value) {
          if (!value) return true;
          if (!/^1[1023456789]\d{9}$/.test(value) && value.length != 8) {
            return false;
          }
          return true;
        }
      },

      forbidPureDigitsRule: {
        validator: (rule, value, callback) => {
          if (value) {
            // 限制字符串长度不小于6位
            if (value.length < 6) {
              callback(new Error('长度不能小于6位'));
              // } else if (/^[0-9]*$/.test(value)) {
              //   callback(new Error('不能为纯数字'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        }
      },
      refereeList: [],
      trainerList: [],
      groupUserList: [],
      mentorList: [],
      userList: [],
      qwUserList: [],
      busserList: []
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.getCardType();
    this.$nextTick(() => {
      this.$refs.selectTree && this.$refs.selectTree.openChange();
    });
  },
  methods: {
    changeIfaType() {
      if (this.formData.ifaType == 2) {
        this.$set(this.formData, 'isLicence', 0);
      }
      this.setStaffNo();
    },
    setStaffNo() {
      if (this.formData.id) {
        return;
      }
      this.$http({
        url: '/buz/userBase/generateIfaStaffNo',
        type: 'GET',
        data: {
          ifaType: this.formData.ifaType
        }
      }).then(res => {
        this.$set(this.formData, 'staffNo', res.data);
      });
    },
    changeLeaderId(val) {
      let item = this.groupUserList.find(i => i.id == val);
      console.log(item);
      this.$set(this.formData, 'groupId', item.groupId);
      this.$set(this.formData, 'groupName', item.groupName);
    },
    // 修改团队
    changeGroupId() {
      // 机构下直接新增员工的是否团队长只能选否
      if (!this.formData.groupId) {
        this.formData.isLeader = '0';
      }
    },
    strLength() {
      return {
        required: false,
        message: '请输入正确的护照号',
        trigger: 'change',
        validator(rule, value) {
          if (!value) return true;
          if (value.length != 8 && value.length != 9) {
            return false;
          }
          return true;
        }
      };
    },
    getCardType() {
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'POST',
        data: {
          code: 'USER_CARD_TYPE'
        }
      }).then(res => {
        this.idTypeList = res.data;
      });
    },
    getBusserList() {
      this.$http({
        url: '/system/users/read/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999,
          userType: 4
        }
      }).then(res => {
        this.busserList = res.data || [];
      });
    },
    // 获取团队列表
    getGroupList() {
      this.$http({
        url: '/buz/groupBase/read/list',
        type: 'POST',
        data: {
          tenantId: this.formData.tenantId,
          pageSize: 999,
          pageNo: 1
        }
      }).then(res => {
        this.groupList = res.data;
        if (this.groupList.length == 1) {
          this.formData.groupId = this.groupList[0].groupId;
        }
      });
    },
    save() {
      this.$refs.form.validate().then(isok => {
        console.log(this.formData);
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));

        if (formData.date?.length) {
          formData.ifaLicenceStartDate = formData.date[0];
          formData.ifaLicenceEndDate = formData.date[1];
        } else {
          formData.ifaLicenceStartDate = null;
          formData.ifaLicenceEndDate = null;
        }
        formData.date = null;

        // 校验密码
        if (!formData.id) {
          if (formData.password != formData.password1) {
            return this.$notice.error('密码输入不一致');
          }
          if (!this.verification(formData.password)) {
            return;
          }
        }
        // 校验账号
        const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");
        // 新增或者解密后校验
        if ((!formData.id || formData.accountEyeShow) && regTeShu.test(formData.account)) {
          return this.$notice.error('登录账号支持输入数字、字母和汉字');
        }

        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          type: 'POST',
          url: formData.id ? '/buz/userBase/edit' : '/buz/userBase/add',
          data: formData
        })
          .then(res => {
            this.visible = false;
            this.loading = false;
            this.$emit('success');
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      });
    },
    getDetail() {
      this.$http({
        type: 'GET',
        url: '/buz/userBase/read/detail',
        data: { id: this.formData.id }
      }).then(res => {
        if (res.data.ifaLicenceEndDate && res.data.ifaLicenceStartDate) {
          res.data.date = [res.data.ifaLicenceStartDate, res.data.ifaLicenceEndDate];
        }
        if (!res.data.mobile) {
          this.formData.mobileEyeShow = true;
        }
        if (res.data.ifaLevel) {
          res.data.ifaLevel = res.data.ifaLevel.toString();
        }
        if (!res.data.idNo) {
          this.formData.idNoEyeShow = true;
        }
        if (res.data.email) {
          this.formData.email1 = res.data.email;
        }

        this.formData = { ...this.formData, ...res.data };
      });
    },
    getUserList() {
      this.$http({
        type: 'POST',
        url: '/buz/userBase/read/list',
        data: {
          pageSize: 9999,
          pageNo: 1,
          isAll: 1
        }
      }).then(res => {
        let list = res.data;
        this.userList = res.data;
        this.trainerList = list.filter(item => item.id != this.formData.id);
        if (this.isIFA) {
          this.mentorList = list.filter(item => item.ifaLevel != 1 && item.ifaLevel != 2);
          this.refereeList = list;
        } else {
          this.refereeList = list.filter(item => item.id != this.formData.id);
          this.mentorList = list.filter(item => item.id != this.formData.id && item.ifaLevel != 1 && item.ifaLevel != 2);
        }
        this.groupUserList = list.filter(item => item.isLeader == 1 && item.ifaLevel != 1 && item.ifaLevel != 2);
      });
    },
    changeIfaLevel(val) {
      // this.$set(this.formData, 'ifaLevel', val);
      console.log('执行了吗', val);
      if (val == 1 || val == 2) {
        this.$set(this.formData, 'isLeader', '0');
      }
    },
    changeIsLeader(val) {
      console.log(val);
      if (val == 1 || (val == 0 && this.data.leaderId == this.formData.leaderId)) {
        this.$set(this.formData, 'leaderId', '');
      } else if (this.data.leaderId && this.data.leaderId != this.formData.leaderId) {
        this.$set(this.formData, 'leaderId', this.data.leaderId);
      }
    },
    open(data) {
      console.log('data', data);
      this.data = data;
      this.loading = false;
      this.visible = true;
      this.formData = {
        groupId: data.groupId,
        orgName: data.orgName,
        tenantId: data.tenantId,
        leaderId: data.leaderId,
        groupName: data.groupName,
        status: '1',
        entryTime: '',
        isLeader: '0',
        mobile: '',
        name: '',
        idNo: '',
        idType: '',
        account: '',
        password: '',
        password1: '',
        ifaLevel: '',
        id: '',
        email: '',
        busserId: '',
        operatorName: ''
      };
      if (data.id) {
        this.formData.id = data.id;
        this.formData.groupId = data.groupId;
        this.getDetail();
      } else {
        if (this.userInfo.isIFA) {
          this.formData.ifaType = 1;
          this.setStaffNo();
        }
      }
      this.getGroupList();
      if (this.userInfo.isIFA) {
        this.getUserList();
        this.queryWeTalkUser();
        this.getBusserList();
      }
      this.clearValidate('form');
    },
    // 查询企微用户
    queryWeTalkUser() {
      this.$http({
        type: 'GET',
        url: '/buz/userBase/queryWeTalkUser',
        data: {}
      }).then(res => {
        if (res.data) {
          this.qwUserList = res.data;
        }
      });
    },
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error('密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种'); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    },
    // 解密
    openEye(row, key) {
      if (!row['validName' + key]) {
        this.$refs.validUserNameRef.open(row, key);
        return;
      }
      if (!row[key + 'EyeShow']) {
        const map = {
          account: 0,
          mobile: 2,
          idNo: 1,
          email: 4
        };
        this.descrypt(
          {
            query: row.id,
            operationFunction: 1,
            operationType: map[key]
          },
          row,
          key
        ).then(() => {
          this.$set(row, key + 'EyeShow', true);
        });
      } else {
        this.$set(row, key + 'EyeShow', false);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.add-user-wrap {
  h2 {
    font-weight: 700;
    margin-bottom: 10px;
  }
  .info-text {
    font-size: 12px;
    color: #a8adb7;
    margin-left: -62px;
    margin-top: 20px;
    float: left;
  }
  .full {
    width: 100%;
  }
}
</style>
